import React from 'react';
import { useLanguageStore } from '../store';

export default function TermsPage() {
  const language = useLanguageStore((state) => state.language);

  if (language === 'en') {
    return (
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-2">
            Terms and Conditions
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
            Online store iglakmierzejewski.pl
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-10 border-b border-gray-200 dark:border-gray-700 pb-6">
            Effective as of January 1, 2025
          </p>

          <div className="space-y-10 text-gray-700 dark:text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§1</span>
                General Provisions
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  These Terms and Conditions define the rules for using the online store operating at iglakmierzejewski.pl, in particular the rules for placing orders, concluding sales agreements, providing electronic services, and complaint procedures.
                </li>
                <li>
                  The Store is operated by MERCATUS IT Michał Mierzejewski, with its registered office at Białogórne 5, 96-230 Białogórne, Tax Identification Number (NIP): 8351621513, National Business Registry Number (REGON): 541142920 (hereinafter referred to as the "Seller").
                </li>
                <li>
                  Contact with the Seller is possible via email at: iglakmierz@gmail.com.
                </li>
                <li>
                  These Terms and Conditions are continuously available on the Store's website, enabling every user to obtain, reproduce, and record the content thereof.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§2</span>
                Definitions
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  <strong className="text-gray-900 dark:text-white">Customer</strong> — a natural person, legal person, or organizational unit without legal personality that has been granted legal capacity by law, who places an order through the Store.
                </li>
                <li>
                  <strong className="text-gray-900 dark:text-white">Consumer</strong> — a Customer who is a natural person performing a legal act not directly related to their business or professional activity.
                </li>
                <li>
                  <strong className="text-gray-900 dark:text-white">Entrepreneur with consumer rights</strong> — a natural person entering into an agreement directly related to their business activity, when it is clear from the content of the agreement that it does not have a professional character for that person.
                </li>
                <li>
                  <strong className="text-gray-900 dark:text-white">Product</strong> — live plants, trees, shrubs, and other goods offered for sale through the Store.
                </li>
                <li>
                  <strong className="text-gray-900 dark:text-white">Additional Service</strong> — a service related to the order of Products, in particular transport or planting.
                </li>
                <li>
                  <strong className="text-gray-900 dark:text-white">Order</strong> — a declaration of intent by the Customer aimed at concluding a sales agreement for Products or an agreement for the provision of Additional Services.
                </li>
                <li>
                  <strong className="text-gray-900 dark:text-white">Sales Agreement</strong> — a product sales agreement concluded between the Customer and the Seller via the Store.
                </li>
                <li>
                  <strong className="text-gray-900 dark:text-white">Wholesale Order</strong> — an order with a minimum total value of 2,000 PLN gross, fulfilled at wholesale prices.
                </li>
                <li>
                  <strong className="text-gray-900 dark:text-white">Retail Order</strong> — an order below the threshold specified for Wholesale Orders.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§3</span>
                Types and Scope of Electronic Services
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  Through the Store, the Seller provides electronic services consisting of: enabling browsing of the Store's offer, enabling the placement of Orders, and enabling contact with the Seller via forms or email.
                </li>
                <li>
                  Use of the Store is conditional on meeting the technical requirements set out in §13 of the Terms.
                </li>
                <li>
                  The Customer is obligated to use the Store in accordance with the law, good practices, and the provisions of these Terms.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§4</span>
                Rules for Placing Orders
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  Orders may be placed through the Store 24 hours a day, 7 days a week.
                </li>
                <li>
                  To place an Order, the Customer selects Products, adds them to the cart, provides data necessary for order fulfillment, selects the delivery and payment method, and confirms the Order.
                </li>
                <li>
                  The Customer is obligated to provide truthful, current, and complete data.
                </li>
                <li>
                  The minimum Wholesale Order value is 2,000 PLN gross. Orders below this value are fulfilled at retail prices.
                </li>
                <li>
                  Information about Products presented in the Store constitutes an invitation to conclude an agreement within the meaning of the Civil Code.
                </li>
                <li>
                  After placing an Order, the Customer receives an email confirming its receipt.
                </li>
                <li>
                  The Sales Agreement is concluded when the Seller confirms the Order for fulfillment.
                </li>
                <li>
                  Due to the specific nature of the Products sold, in particular their seasonality and natural character, availability may change. If fulfillment is impossible, the Seller will promptly inform the Customer and refund any payments already made.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§5</span>
                Prices and Payments
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  All prices presented in the Store are gross prices, expressed in Polish zloty (PLN), and include VAT at the applicable rate, generally 8% for the offered Products, unless otherwise indicated for a specific Product.
                </li>
                <li>
                  Product prices do not include delivery costs or Additional Services, unless expressly stated otherwise.
                </li>
                <li>
                  Payments are processed through the Stripe payment operator or another method indicated in the Store.
                </li>
                <li>
                  The Customer is obligated to make payment within 3 business days of placing the Order, unless they have chosen a payment method requiring a different settlement procedure.
                </li>
                <li>
                  In case of non-payment within the deadline, the Seller may cancel the Order.
                </li>
                <li>
                  For Wholesale Orders, individual payment arrangements are possible.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§6</span>
                Delivery and Transport
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Seller delivers throughout Poland and, by individual arrangement, to other European countries.
                </li>
                <li>
                  Transport costs 5 PLN per kilometer, calculated from the Seller's premises to the delivery address provided by the Customer, unless otherwise agreed.
                </li>
                <li>
                  The Customer may collect Products in person after arranging a time in advance.
                </li>
                <li>
                  Delivery dates are arranged individually with the Customer.
                </li>
                <li>
                  The Seller makes every effort to deliver on the agreed date but reserves the right to change dates for reasons beyond their control, including weather conditions, seasonality, or force majeure events.
                </li>
                <li>
                  Upon receiving the delivery, the Customer should inspect the condition of the shipment. In case of damage in transit, it is recommended to prepare a damage report and contact the Seller promptly.
                </li>
                <li>
                  Risk of accidental loss or damage to the Product transfers to the Consumer upon delivery, and in the case of non-Consumer Customers — upon delivery to the carrier, unless mandatory provisions state otherwise.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§7</span>
                Planting Service
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Seller offers an optional planting service at the cost of 30 PLN per tree, unless otherwise individually agreed.
                </li>
                <li>
                  The planting service is available only for orders with delivery.
                </li>
                <li>
                  The planting service covers basic planting of plants at the designated location.
                </li>
                <li>
                  Site preparation, soil improvement, drainage, irrigation, or other additional work is not included unless otherwise agreed.
                </li>
                <li>
                  The Seller does not guarantee that planted plants will take root if their condition is affected by factors beyond the Seller's control, including weather conditions, soil quality, maintenance method, watering, fertilization, or interference by third parties.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§8</span>
                Right of Withdrawal
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  Consumers and Entrepreneurs with consumer rights generally have the right to withdraw from a distance contract within 14 days, unless one of the exceptions provided by law applies.
                </li>
                <li>
                  Due to the nature of the Products sold, the right of withdrawal does not apply to Products that are perishable goods or have a short shelf life, in particular live plants, trees, shrubs, and other horticultural products offered by the Seller.
                </li>
                <li>
                  The exclusion of the right of withdrawal referred to in paragraph 2 results from Article 38, point 4 of the Consumer Rights Act.
                </li>
                <li>
                  If the Order also includes goods or services for which the right of withdrawal is not excluded, the right to withdraw is assessed separately for each service, in accordance with applicable regulations.
                </li>
                <li>
                  For questions regarding the right of withdrawal, the Customer may contact the Seller before placing an Order.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§9</span>
                Complaints
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Seller is obligated to deliver Products conforming to the agreement.
                </li>
                <li>
                  The Customer may file a complaint about a Product, delivery, or Order fulfillment by sending a message to: iglakmierz@gmail.com.
                </li>
                <li>
                  A complaint should include: Customer identification data, description of the issue, Customer's request, and photographic documentation where possible.
                </li>
                <li>
                  Complaints are processed within 14 days of receipt.
                </li>
                <li>
                  Due to the specific nature of live plants and the need for quick assessment, the Seller requests that quality or damage complaints be submitted promptly after receipt, preferably within 3 days of delivery. This does not limit Consumer rights under mandatory law.
                </li>
                <li>
                  If a complaint is accepted, the Seller will take appropriate action, including replacing the Product, reducing the price, or refunding the appropriate amount.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§10</span>
                Liability
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Seller is not liable for deterioration of plants resulting from circumstances beyond the Seller's control that occurred after the Products were delivered to the Customer.
                </li>
                <li>
                  The Seller is not liable for the consequences of the Customer providing incorrect or incomplete data.
                </li>
                <li>
                  In relations with Customers who are not Consumers or Entrepreneurs with consumer rights, the Seller's liability for non-performance or improper performance of the agreement is limited to the net value of the given Order.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§11</span>
                Personal Data
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The controller of Customer personal data is the Seller.
                </li>
                <li>
                  Detailed rules for personal data processing are set out in the Privacy Policy available on the Store's website.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§12</span>
                Intellectual Property
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  All content published on the Store's website, including texts, photographs, graphics, logos, and graphic elements, is subject to legal protection.
                </li>
                <li>
                  Use of this content beyond permitted use requires prior consent of the Seller or other authorized entity.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§13</span>
                Technical Requirements
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  Using the Store requires a device with internet access, a current web browser supporting JavaScript and cookies, and an active email account — when placing an Order.
                </li>
                <li>
                  The Seller is not liable for technical problems resulting from the Customer not meeting the above requirements.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§14</span>
                Out-of-Court Dispute Resolution
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Consumer may use out-of-court methods of complaint resolution and claim enforcement, including mediation or the assistance of the relevant Consumer Ombudsman or the Trade Inspection.
                </li>
                <li>
                  Detailed information about out-of-court dispute resolution options is available from the relevant public authorities and institutions.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§15</span>
                Final Provisions
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Seller reserves the right to amend these Terms for important reasons, including changes in law, payment or delivery methods, expansion of Store functionality, or changes in the Seller's data.
                </li>
                <li>
                  Changes to the Terms do not affect the vested rights of Customers who placed Orders before the changes came into effect.
                </li>
                <li>
                  In matters not regulated by these Terms, Polish law applies.
                </li>
                <li>
                  In disputes with Consumers, court jurisdiction is determined by generally applicable law.
                </li>
                <li>
                  These Terms are effective as of January 1, 2025.
                </li>
              </ol>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
            <div className="text-sm text-gray-500 dark:text-gray-400 space-y-1">
              <p className="font-semibold text-gray-700 dark:text-gray-300">MERCATUS IT Michał Mierzejewski</p>
              <p>Białogórne 5, 96-230 Białogórne</p>
              <p>NIP: 8351621513 | REGON: 541142920</p>
              <p>Email: iglakmierz@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-8 md:p-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-2">
          Regulamin sklepu internetowego
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
          iglakmierzejewski.pl
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-10 border-b border-gray-200 dark:border-gray-700 pb-6">
          Obowiązuje od dnia 1 stycznia 2025 r.
        </p>

        <div className="space-y-10 text-gray-700 dark:text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§1</span>
              Postanowienia ogólne
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Niniejszy Regulamin określa zasady korzystania ze sklepu internetowego działającego pod adresem iglakmierzejewski.pl, w szczególności zasady składania zamówień, zawierania umów sprzedaży, świadczenia usług drogą elektroniczną oraz zasady reklamacji.
              </li>
              <li>
                Sklep prowadzony jest przez MERCATUS IT Michał Mierzejewski, z adresem prowadzenia działalności: Białogórne 5, 96-230 Białogórne, NIP: 8351621513, REGON: 541142920, zwany dalej „Sprzedawcą".
              </li>
              <li>
                Kontakt ze Sprzedawcą możliwy jest za pośrednictwem poczty elektronicznej pod adresem: iglakmierz@gmail.com.
              </li>
              <li>
                Regulamin jest udostępniany nieodpłatnie na stronie internetowej Sklepu w sposób umożliwiający jego pozyskanie, odtwarzanie i utrwalanie.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§2</span>
              Definicje
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                <strong className="text-gray-900 dark:text-white">Klient</strong> — osoba fizyczna, osoba prawna albo jednostka organizacyjna nieposiadająca osobowości prawnej, której ustawa przyznaje zdolność prawną, składająca zamówienie za pośrednictwem Sklepu.
              </li>
              <li>
                <strong className="text-gray-900 dark:text-white">Konsument</strong> — Klient będący osobą fizyczną dokonującą czynności prawnej niezwiązanej bezpośrednio z jego działalnością gospodarczą lub zawodową.
              </li>
              <li>
                <strong className="text-gray-900 dark:text-white">Przedsiębiorca na prawach konsumenta</strong> — osoba fizyczna zawierająca umowę bezpośrednio związaną z jej działalnością gospodarczą, gdy z treści tej umowy wynika, że nie ma ona dla tej osoby charakteru zawodowego.
              </li>
              <li>
                <strong className="text-gray-900 dark:text-white">Produkt</strong> — rośliny żywe, drzewa, krzewy oraz inne towary oferowane do sprzedaży za pośrednictwem Sklepu.
              </li>
              <li>
                <strong className="text-gray-900 dark:text-white">Usługa dodatkowa</strong> — usługa związana z zamówieniem Produktów, w szczególności transport lub sadzenie.
              </li>
              <li>
                <strong className="text-gray-900 dark:text-white">Zamówienie</strong> — oświadczenie woli Klienta zmierzające bezpośrednio do zawarcia umowy sprzedaży Produktów lub umowy o świadczenie Usług dodatkowych.
              </li>
              <li>
                <strong className="text-gray-900 dark:text-white">Umowa sprzedaży</strong> — umowa sprzedaży Produktów zawarta pomiędzy Klientem a Sprzedawcą za pośrednictwem Sklepu.
              </li>
              <li>
                <strong className="text-gray-900 dark:text-white">Zamówienie hurtowe</strong> — zamówienie o minimalnej wartości 2 000 zł brutto, realizowane na warunkach hurtowych.
              </li>
              <li>
                <strong className="text-gray-900 dark:text-white">Zamówienie detaliczne</strong> — zamówienie poniżej progu wskazanego dla Zamówienia hurtowego.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§3</span>
              Rodzaje i zakres usług świadczonych drogą elektroniczną
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Za pośrednictwem Sklepu Sprzedawca świadczy usługi drogą elektroniczną polegające na: umożliwieniu przeglądania oferty Sklepu, umożliwieniu składania Zamówień, umożliwieniu kontaktu ze Sprzedawcą za pośrednictwem formularzy lub poczty elektronicznej.
              </li>
              <li>
                Korzystanie ze Sklepu jest możliwe pod warunkiem spełnienia wymagań technicznych określonych w §13 Regulaminu.
              </li>
              <li>
                Klient zobowiązany jest do korzystania ze Sklepu w sposób zgodny z prawem, dobrymi obyczajami i postanowieniami niniejszego Regulaminu.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§4</span>
              Zasady składania zamówień
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Zamówienia mogą być składane przez Sklep 24 godziny na dobę, 7 dni w tygodniu.
              </li>
              <li>
                W celu złożenia Zamówienia Klient: wybiera Produkt lub Produkty, dodaje je do koszyka, podaje dane niezbędne do realizacji Zamówienia, wybiera sposób dostawy i płatności, potwierdza Zamówienie.
              </li>
              <li>
                Klient zobowiązany jest do podania danych prawdziwych, aktualnych i kompletnych.
              </li>
              <li>
                Minimalna wartość Zamówienia hurtowego wynosi 2 000 zł brutto. Zamówienia poniżej tej wartości realizowane są według cen detalicznych.
              </li>
              <li>
                Informacje o Produktach prezentowane w Sklepie stanowią zaproszenie do zawarcia umowy w rozumieniu przepisów Kodeksu cywilnego.
              </li>
              <li>
                Po złożeniu Zamówienia Klient otrzymuje wiadomość e-mail potwierdzającą jego otrzymanie.
              </li>
              <li>
                Umowa sprzedaży zostaje zawarta z chwilą potwierdzenia przez Sprzedawcę przyjęcia Zamówienia do realizacji.
              </li>
              <li>
                Ze względu na specyfikę sprzedawanych Produktów, w szczególności ich sezonowość i naturalny charakter, dostępność Produktów może ulec zmianie. W przypadku braku możliwości realizacji Zamówienia Sprzedawca niezwłocznie poinformuje o tym Klienta oraz zwróci otrzymane płatności.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§5</span>
              Ceny i płatności
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Wszystkie ceny prezentowane w Sklepie są cenami brutto, wyrażonymi w złotych polskich (PLN), i zawierają podatek VAT według właściwej stawki, co do zasady 8% dla oferowanych Produktów, chyba że przy danym Produkcie wskazano inaczej.
              </li>
              <li>
                Ceny Produktów nie obejmują kosztów dostawy ani Usług dodatkowych, chyba że wyraźnie zaznaczono inaczej.
              </li>
              <li>
                Płatności realizowane są za pośrednictwem operatora płatności Stripe lub inną metodą wskazaną w Sklepie.
              </li>
              <li>
                Klient zobowiązany jest do dokonania płatności w terminie 3 dni roboczych od dnia złożenia Zamówienia, chyba że wybrał metodę płatności wymagającą innego trybu rozliczenia.
              </li>
              <li>
                W przypadku braku płatności w terminie, Sprzedawca może anulować Zamówienie.
              </li>
              <li>
                W przypadku Zamówień hurtowych możliwe są indywidualne ustalenia dotyczące sposobu płatności.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§6</span>
              Dostawa i transport
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Sprzedawca realizuje dostawy na terenie Polski oraz, po indywidualnym uzgodnieniu, do innych krajów europejskich.
              </li>
              <li>
                Koszt transportu wynosi 5 zł za kilometr, liczony od siedziby Sprzedawcy do adresu dostawy wskazanego przez Klienta, chyba że strony ustalą inaczej.
              </li>
              <li>
                Klient może odebrać Produkty osobiście po wcześniejszym uzgodnieniu terminu.
              </li>
              <li>
                Termin dostawy ustalany jest indywidualnie z Klientem.
              </li>
              <li>
                Sprzedawca dokłada należytej staranności, aby dostawa nastąpiła w ustalonym terminie, jednak zastrzega możliwość zmiany terminu z przyczyn od niego niezależnych, w szczególności z uwagi na warunki atmosferyczne, sezonowość lub zdarzenia o charakterze siły wyższej.
              </li>
              <li>
                Przy odbiorze dostawy Klient powinien sprawdzić stan przesyłki. W przypadku uszkodzeń powstałych w transporcie zaleca się sporządzenie protokołu szkody oraz niezwłoczny kontakt ze Sprzedawcą.
              </li>
              <li>
                Ryzyko przypadkowej utraty lub uszkodzenia Produktu przechodzi na Konsumenta z chwilą jego wydania Konsumentowi, a w przypadku Klienta niebędącego Konsumentem – z chwilą wydania Produktu przewoźnikowi, chyba że bezwzględnie obowiązujące przepisy stanowią inaczej.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§7</span>
              Usługa sadzenia
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Sprzedawca oferuje opcjonalną usługę sadzenia w cenie 30 zł za drzewo, chyba że indywidualnie uzgodniono inaczej.
              </li>
              <li>
                Usługa sadzenia dostępna jest wyłącznie przy zamówieniach z dostawą.
              </li>
              <li>
                Usługa sadzenia obejmuje podstawowe posadzenie roślin we wskazanym miejscu.
              </li>
              <li>
                Przygotowanie terenu, poprawa gleby, drenaż, nawodnienie lub inne prace dodatkowe nie są objęte usługą, chyba że strony ustalą inaczej.
              </li>
              <li>
                Sprzedawca nie gwarantuje przyjęcia się roślin po posadzeniu, jeżeli na ich stan wpływ mają czynniki niezależne od Sprzedawcy, w szczególności warunki atmosferyczne, jakość gleby, sposób pielęgnacji, podlewanie, nawożenie lub ingerencja osób trzecich.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§8</span>
              Prawo odstąpienia od umowy
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Konsumentowi oraz Przedsiębiorcy na prawach konsumenta co do zasady przysługuje prawo odstąpienia od umowy zawartej na odległość w terminie 14 dni, chyba że zachodzi jeden z wyjątków przewidzianych przepisami prawa.
              </li>
              <li>
                Z uwagi na charakter sprzedawanych w Sklepie Produktów, prawo odstąpienia od umowy nie przysługuje w odniesieniu do Produktów stanowiących rzeczy ulegające szybkiemu zepsuciu lub mających krótki termin przydatności do użycia, w szczególności żywych roślin, drzew, krzewów oraz innych produktów ogrodniczych oferowanych przez Sprzedawcę.
              </li>
              <li>
                Wyłączenie prawa odstąpienia, o którym mowa w ust. 2, wynika z art. 38 pkt 4 ustawy o prawach konsumenta.
              </li>
              <li>
                Jeżeli przedmiotem Zamówienia są również towary lub usługi, wobec których prawo odstąpienia nie jest wyłączone, uprawnienie do odstąpienia ocenia się odrębnie dla każdego świadczenia, zgodnie z obowiązującymi przepisami.
              </li>
              <li>
                W przypadku pytań dotyczących możliwości odstąpienia od umowy Klient może skontaktować się ze Sprzedawcą przed złożeniem Zamówienia.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§9</span>
              Reklamacje
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Sprzedawca zobowiązany jest dostarczyć Produkt zgodny z umową.
              </li>
              <li>
                Klient może złożyć reklamację dotyczącą Produktu, dostawy albo realizacji Zamówienia, wysyłając wiadomość na adres: iglakmierz@gmail.com.
              </li>
              <li>
                Reklamacja powinna zawierać: dane Klienta umożliwiające identyfikację Zamówienia, opis problemu, żądanie Klienta, w miarę możliwości dokumentację fotograficzną.
              </li>
              <li>
                Reklamacje są rozpatrywane w terminie 14 dni od dnia ich otrzymania.
              </li>
              <li>
                Ze względu na specyfikę roślin żywych oraz konieczność szybkiej oceny ich stanu, Sprzedawca prosi o zgłaszanie zastrzeżeń dotyczących jakości lub uszkodzeń Produktów niezwłocznie po ich otrzymaniu, najlepiej w terminie 3 dni od dostawy. Powyższe nie ogranicza uprawnień Konsumenta wynikających z bezwzględnie obowiązujących przepisów prawa.
              </li>
              <li>
                W przypadku uznania reklamacji Sprzedawca, zgodnie z obowiązującymi przepisami, podejmie odpowiednie działania, w szczególności wymieni Produkt, obniży cenę albo zwróci odpowiednią część lub całość należności.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§10</span>
              Odpowiedzialność
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Sprzedawca nie ponosi odpowiedzialności za pogorszenie stanu roślin wynikające z okoliczności niezależnych od Sprzedawcy, które wystąpiły po wydaniu Produktów Klientowi, w szczególności niewłaściwego transportu po odbiorze własnym, nieprawidłowego sadzenia, braku podlewania, niewłaściwej pielęgnacji lub działania czynników atmosferycznych.
              </li>
              <li>
                Sprzedawca nie ponosi odpowiedzialności za skutki podania przez Klienta nieprawidłowych lub niekompletnych danych.
              </li>
              <li>
                W stosunku do Klientów niebędących Konsumentami oraz Przedsiębiorcami na prawach konsumenta odpowiedzialność Sprzedawcy z tytułu niewykonania lub nienależytego wykonania umowy ogranicza się do wartości netto danego Zamówienia, z wyłączeniem szkód utraconych korzyści, chyba że szkoda została wyrządzona umyślnie.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§11</span>
              Dane osobowe
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Administratorem danych osobowych Klientów jest Sprzedawca.
              </li>
              <li>
                Szczegółowe zasady przetwarzania danych osobowych określa Polityka Prywatności dostępna na stronie Sklepu.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§12</span>
              Własność intelektualna
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Wszelkie treści zamieszczone w Sklepie, w szczególności teksty, zdjęcia, grafiki, logotypy i elementy graficzne, podlegają ochronie prawnej.
              </li>
              <li>
                Korzystanie z tych treści poza dozwolonym użytkiem wymaga uprzedniej zgody Sprzedawcy lub innego uprawnionego podmiotu.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§13</span>
              Wymagania techniczne
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Do korzystania ze Sklepu wymagane są: urządzenie z dostępem do Internetu, aktualna przeglądarka internetowa obsługująca JavaScript i pliki cookies, aktywne konto poczty elektronicznej – w przypadku składania Zamówienia.
              </li>
              <li>
                Sprzedawca nie ponosi odpowiedzialności za problemy techniczne wynikające z niespełnienia przez Klienta powyższych wymagań.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§14</span>
              Pozasądowe sposoby rozpatrywania sporów
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Konsument ma możliwość skorzystania z pozasądowych sposobów rozpatrywania reklamacji i dochodzenia roszczeń, zgodnie z obowiązującymi przepisami, w szczególności poprzez mediację lub pomoc właściwego miejscowo rzecznika konsumentów albo Inspekcji Handlowej.
              </li>
              <li>
                Szczegółowe informacje o możliwościach skorzystania z pozasądowych sposobów rozpatrywania sporów dostępne są u właściwych organów i instytucji publicznych.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§15</span>
              Postanowienia końcowe
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Sprzedawca zastrzega sobie prawo do zmiany Regulaminu z ważnych przyczyn, w szczególności w przypadku zmiany przepisów prawa, zmiany sposobów płatności lub dostawy, rozszerzenia funkcjonalności Sklepu albo zmiany danych Sprzedawcy.
              </li>
              <li>
                Zmiany Regulaminu nie wpływają na prawa nabyte Klientów, którzy złożyli Zamówienie przed wejściem w życie zmian.
              </li>
              <li>
                W sprawach nieuregulowanych w Regulaminie zastosowanie mają przepisy prawa polskiego.
              </li>
              <li>
                W sporach z Konsumentami właściwość sądu określają przepisy powszechnie obowiązującego prawa.
              </li>
              <li>
                Regulamin obowiązuje od dnia 1 stycznia 2025 r.
              </li>
            </ol>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
          <div className="text-sm text-gray-500 dark:text-gray-400 space-y-1">
            <p className="font-semibold text-gray-700 dark:text-gray-300">MERCATUS IT Michał Mierzejewski</p>
            <p>Białogórne 5, 96-230 Białogórne</p>
            <p>NIP: 8351621513 | REGON: 541142920</p>
            <p>Email: iglakmierz@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}
